import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=ef5947ee&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=ef5947ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5947ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef5947ee')) {
      api.createRecord('ef5947ee', component.options)
    } else {
      api.reload('ef5947ee', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=ef5947ee&scoped=true&", function () {
      api.rerender('ef5947ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/roles/Form.vue"
export default component.exports